<script>
import { page, batchDel } from '@/api/general/geAttachment'
import GeAttachmentEditDialog from './GeAttachmentEditDialog.vue'
import EuTableToolbar from '@/components/Crud/EuTableToolbar/index.vue'
import ContentBlock from '../ContentLayout/ContentBlock.vue';
import { archiveFilesToZip } from '@/utils/download'
import { IGNORE_PERMISSION } from '@/utils/constants'

const DEFAULT_OPT_SHOW = {
  add: true,
  edit: true,
  del: true,
  export: true,

  sort: false,
  import: false,
  searchToggle: false,
  columnSetting: false
}
const DEFAULT_PERMISSION = {
  add: [IGNORE_PERMISSION],
  del: [IGNORE_PERMISSION],
  edit: [IGNORE_PERMISSION],
  export: [IGNORE_PERMISSION],
}

export default {
  name: 'AttachmentContentBlock',
  components: {
    ContentBlock,
    EuTableToolbar,
    GeAttachmentEditDialog
  },
  props: {
    businessId: {
      type: Number,
      required: false,
      default: null
    },
    businessSubId1: {
      type: Number,
      required: false,
      default: null
    },
    businessSubId2: {
      type: Number,
      required: false,
      default: null
    },
    businessSubId3: {
      type: Number,
      required: false,
      default: null
    },
    businessSubId4: {
      type: Number,
      required: false,
      default: null
    },
    businessAttr1: {
      type: String,
      required: false,
      default: null
    },
    businessAttr2: {
      type: String,
      required: false,
      default: null
    },
    // 参考：$enums.ATTACHMENT_BUSINESS_TYPE.[].value
    businessType: {
      type: Number,
      required: true
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    permission: {
      type: Object,
      default: () => {
        return { }
      }
    },
    optShow: {
      type: Object,
      default: () => {
        return { }
      }
    },
    immediate: {
      type: Boolean,
      default: true
    },
    tableOperShow: {
      type: Boolean,
      default: true
    },
    /**
     * 手动模式：开启后，新增和修改不会操作数据库
     */
    manual: {
      type: Boolean,
      default: false
    },
    formConfig: {
      type: Object,
      default: () => {
        return {
          businessAttr1Show: false,
          businessAttr1Label: '业务属性1',
          businessAttr2Show: false,
          businessAttr2Label: '业务属性2'
        }
      }
    },
    /**
     * 新增时扩展数据
     */
    addExtra: {
      type: Object,
      default: () => {
        return {}
      }
    },
    /**
     * 监听businessId变化
     */
    watchBusinessId: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      list: [],
      total: 0,

      queryParams: {
        businessId: null,
        businessSubId1: null,
        businessSubId2: null,
        businessSubId3: null,
        businessSubId4: null,
        businessType: null,
        page: 1,
        size: 10,
        sort: []
      },

      multipleDisabled: true,
    };
  },
  computed: {
    fullOptShow() {
      let manualOptShow = {}
      if (this.manual) {
        manualOptShow = {
          refresh: false,
          export: false
        }
      }
      return Object.assign({}, DEFAULT_OPT_SHOW, manualOptShow, this.optShow)
    },
    fullPermission() {
      return Object.assign({}, DEFAULT_PERMISSION, this.permission)
    }
  },
  watch: {
    businessId: {
      handler(value, old) {
        if (this.watchBusinessId && old != undefined) {
          this.onQuery()
        }
      },
      immediate: true
    },
  },
  mounted() {
    if (this.immediate && this.businessId) {
      this.onQuery()
    }
  },
  methods: {
    onQuery() {
      if (this.manual) {
        return
      }
      this.loading = true
      const params = {
        ...this.queryParams,
        businessId: this.businessId,
        businessSubId1: this.businessSubId1,
        businessSubId2: this.businessSubId2,
        businessSubId3: this.businessSubId3,
        businessSubId4: this.businessSubId4,
        businessAttr1: this.businessAttr1,
        businessAttr2: this.businessAttr2,
        businessType: this.businessType
      }
      page(params).then(res => {
        this.list = res.data.records
        this.total = res.data.total
      }).finally(() => {
        this.loading = false
      })
    },
    onRefresh() {
      this.queryParams = this.$options.data().queryParams
      this.onQuery()
    },
    onAdd() {
      this.$refs.geAttachmentEditDialog.open()
    },
    async onExport() {
      await this.onArchiveFile()
    },
    async onArchiveFile() {
      if (this.manual) {
        return
      }
      if (!this.list.length) {
        this.$message.warning('暂无附件可导出')
        return
      }
      let loading = this.$loading({
        lock: true,
        text: '正在查找附件...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const files = this.list.map(item => {
        return {
          fileUrl: item.fileUrl,
          fileName: item.fileName
        }
      })
      try {
        await archiveFilesToZip(files, '附件.zip', {
          beforeDownload: () => {
            loading.close()
            loading = this.$loading({
              lock: true,
              text: '正在下载附件...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            })
          },
          beforeArchive: () => {
            loading.close()
            loading = this.$loading({
              lock: true,
              text: '正在打包附件...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            })
          }
        })
      } catch (e) {
        this.$message.error(e.message)
      } finally {
        loading.close()
      }
    },
    onBatchDel() {
      if (this.manual) {
        const _ids = this.$refs.table.getCheckboxRecords().map(item => item._id)
        this.list = this.list.filter(item => !_ids.includes(item._id))
        return
      }
      const ids = this.$refs.table.getCheckboxRecords().map(item => item.id)
      this.$confirm(this.$t('general.confirm.delete.batch.message', { length: ids.length }), this.$t('general.confirm.title'), {
        confirmButtonText: this.$t('general.confirm.confirm'),
        cancelButtonText: this.$t('general.confirm.cancel'),
        type: 'warning',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            batchDel(ids).then(() => {
              this.$message.success(this.$t('general.confirm.delete.success'))
              done()
              this.onRefresh()
            }).finally(() => {
              instance.confirmButtonLoading = false;
            })
          } else {
            done()
          }
        }
      });
    },
    onSelectionChange({ records }) {
      this.multipleDisabled = !records.length
    },
    onRowUpdate(row) {
      this.$refs.geAttachmentEditDialog.open(row)
    },
    onRowDelete(row) {
      if (this.manual) {
        this.list = this.list.filter(item => item._id !== row._id)
        return
      }
      this.$confirm(this.$t('general.confirm.delete.message', { key: row.fileName }), this.$t('general.confirm.title'), {
        confirmButtonText: this.$t('general.confirm.confirm'),
        cancelButtonText: this.$t('general.confirm.cancel'),
        type: 'warning',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            batchDel([row.id]).then(() => {
              this.$message.success(this.$t('general.confirm.delete.success'))
              done()
              this.onRefresh()
            }).finally(() => {
              instance.confirmButtonLoading = false;
            })
          } else {
            done()
          }
        }
      });
    },
    onEditComplete(row) {
      if (this.manual) {
        if (row._add) {
          this.list.push(row)
        } else {
          this.list = this.list.map(item => {
            if (item._id === row._id) {
              return row
            }
            return item
          })
        }
        return
      }
      this.onRefresh()
    }
  }
}
</script>

<template>
  <content-block>
    <m-block-header v-if="showHeader" title="附件管理" :background="false" style="margin-top: unset;" />
    <div class="content-body">
      <div>
        <slot name="header"></slot>
      </div>
      <eu-table-toolbar
        :multiple-disabled="multipleDisabled"
        :opt-show="fullOptShow"
        :permission="fullPermission"
        :ref-table="$refs.table"
        @add="onAdd"
        @batchDel="onBatchDel"
        @export="onExport"
        @refresh="onRefresh"
      />
      <vxe-table
        id="table"
        border
        resizable
        show-overflow
        ref="table"
        :loading="loading"
        :data="list"
        :row-config="{isHover: true}"
        @checkbox-all="onSelectionChange"
        @checkbox-change="onSelectionChange"
      >
        <vxe-column type="checkbox" width="40" fixed="left"></vxe-column>
        <slot name="columns"></slot>
        <vxe-column
          v-if="formConfig.businessAttr1Show"
          field="businessAttr1"
          :title="formConfig.businessAttr1Label"
          :visible="true"
          min-width="100"
        >
        </vxe-column>
        <vxe-column
          v-if="formConfig.businessAttr2Show"
          field="businessAttr2"
          :title="formConfig.businessAttr2Label"
          :visible="true"
          min-width="100"
        >
        </vxe-column>
        <vxe-column
          field="fileName"
          title="文件名称"
          :visible="true"
          min-width="250"
        >
          <template #default="{ row }">
            <file-preview :link="row.fileUrl">
              <el-link type="primary">{{ row.fileName }}</el-link>
            </file-preview>
          </template>
        </vxe-column>
        <vxe-column
          field="fileSize"
          title="文件大小(kb)"
          :visible="false"
          min-width="100"
        >
        </vxe-column>
        <vxe-column
          field="fileExt"
          title="文件扩展名"
          :visible="false"
          min-width="100"
        >
        </vxe-column>
        <vxe-column
          field="fileDesc"
          title="文件描述"
          :visible="true"
          min-width="140"
          show-overflow="tooltip"
        >
        </vxe-column>
        <template v-if="!manual">
          <vxe-column
            field="createByName"
            title="创建人"
            :visible="true"
            min-width="100"
          >
          </vxe-column>
          <vxe-column
            field="createTime"
            title="创建时间"
            :visible="true"
            min-width="140"
          >
          </vxe-column>
        </template>
        <vxe-column v-if="tableOperShow" :field="$tableColumnField.operation" :title="$t('general.column.operation')" min-width="100" :show-overflow="false" fixed="right">
          <template #default="{ row }">
            <el-button v-if="fullOptShow.edit" v-permissions="fullPermission.edit" type="text" @click="onRowUpdate(row)">{{ $t('general.edit') }}</el-button>
            <el-button v-if="fullOptShow.del" v-permissions="fullPermission.del" type="text" @click="onRowDelete(row)">{{ $t('general.del') }}</el-button>
          </template>
        </vxe-column>
      </vxe-table>
      <pagination
        v-if="!manual"
        :total="total"
        :page.sync="queryParams.page"
        :limit.sync="queryParams.size"
        @pagination="onQuery"
      />
    </div>
    <ge-attachment-edit-dialog
      ref="geAttachmentEditDialog"
      :business-id="businessId"
      :business-sub-id1="businessSubId1"
      :business-sub-id2="businessSubId2"
      :business-sub-id3="businessSubId3"
      :business-sub-id4="businessSubId4"
      :business-attr1="businessAttr1"
      :business-attr2="businessAttr2"
      :business-type="businessType"
      :formConfig="formConfig"
      :manual="manual"
      :add-extra="addExtra"
      @complete="onEditComplete"
    />
  </content-block>
</template>

<style lang="scss" scoped>

</style>
